import type { WardrobeItem } from '../api/virtualUser';
import { categoryRoot } from './wardrobeCategory';

export function mergeWardrobePage(prev: WardrobeItem[], next: WardrobeItem[]): WardrobeItem[] {
  if (next.length === 0) return prev;
  const seen = new Set<string>();
  const out: WardrobeItem[] = [];
  for (const item of prev) {
    if (!item.cloth_id || seen.has(item.cloth_id)) continue;
    seen.add(item.cloth_id);
    out.push(item);
  }
  for (const item of next) {
    if (!item.cloth_id || seen.has(item.cloth_id)) continue;
    seen.add(item.cloth_id);
    out.push(item);
  }
  return out;
}

export function visibleWardrobeItems(items: WardrobeItem[], root: string): WardrobeItem[] {
  return items.filter((item) => {
    if (!item.thumb) return false;
    if (root !== 'all' && categoryRoot(item.category) !== root) return false;
    return true;
  });
}

export function sortWardrobeItems(
  items: WardrobeItem[],
  mode: 'default' | 'category' | 'name'
): WardrobeItem[] {
  if (mode === 'default') return items;
  const list = [...items];
  if (mode === 'category') {
    list.sort(
      (a, b) => a.category.localeCompare(b.category, 'zh') || a.name.localeCompare(b.name, 'zh')
    );
  } else {
    list.sort((a, b) => a.name.localeCompare(b.name, 'zh'));
  }
  return list;
}
